const configuredLinks = {
  membershipCheckout:
    'https://territory.digitalcowboy.io/checkout/?product_id=6405&product_type=membership',
  membershipDetails:
    'https://territory.digitalcowboy.io/en/membership'
};

export default configuredLinks;